import { mapActions } from "vuex";

export default  {
	created () {    
	   this.updateDataPost({ 
		   data: { 
			   data: [],
			   route: 'admin_datoslentes', 
			   tablaPost: ['datos_lentes']
			}
		}) 
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'lenteEditarFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_lente', 
									tablaPost: ['datos_proveedores_lente']
								 }
							 }) 
						break;
						case 'inactivarFtn' :							
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'inactive_lente', 
									tablaPost: ['datos_proveedores_lente']
								 }
							 }) 
						break;

					}
				}
				await this.save(event.save)

				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'lenteEditarFtn':
							if(this.indexData!==false)
							{
								await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})
							}
							else
							{
								let datos= {}
								datos.datos_proveedores_lente = await this.gettersDatalist('datos_proveedores_lente', this.dataForm[this.namePath].datos_proveedores_lente.name)[0]
								await this.pushDataGet({ data: datos})
							}							
						break;
						case 'inactivarFtn':
							await this.spliceDataGet(this.indexData)
						break;

					}
				}
				this.resetGlobal({state: 'indexData'})
				this.resetGlobal({state: 'openModal'})
				this.resetDataForm()
			}
			catch{

			}			
		}		
	},
}
